import { Suspense, useEffect } from 'react';

/// Components
import Index from './jsx/routes/Investor/index';
import { connect, useDispatch } from 'react-redux';
import { Route, Routes, useLocation, useNavigate, useParams, Navigate } from 'react-router-dom';
// action
import { checkAutoLogin } from './services/AuthService';
import { isAuthenticated } from './store/selectors/AuthSelectors';
/// Style
import './vendor/css/bootstrap-select.min.css';
import './styles/css/style.css';
import { Login, Register, RegisterEmail, RegisterPassword, PublicList, ResetPassword, PublicListLite } from '@pages-investor';
import { RegisterType } from './jsx/pages/Investor';
import RegisterLegalPerson from './jsx/pages/Investor/RegisterLegalPerson';
import RegisterConcluded from './jsx/pages/Investor/RegisterConcluded';

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation();
    let navigate = useNavigate();
    let params = useParams();

    return <Component {...props} router={{ location, navigate, params }} />;
  }

  return ComponentWithRouterProp;
}

function Investor(props) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    checkAutoLogin(dispatch, navigate);

    const email = localStorage.getItem('email');
    const id = localStorage.getItem('id');
    const token = localStorage.getItem('access_token_register');
    if (email && id && pathname === '/register') {
      navigate('/register/email');
    }
    if (email && id && token && pathname === '/register/email') {
      navigate('/register/password');
    }
  }, [pathname]);

  const noAuthPaths = ['/publictokens', '/publictokenslite', '/register', '/registertype', '/registerpj', '/register/concluded', '/register/email', '/register/password', '/login', '/reset'];

  let publicRoutes = (
    <Routes>
      <Route path="/login" index element={<Login />} />
      <Route path="/registertype" element={<RegisterType />} />
      <Route path="/registerpj" element={<RegisterLegalPerson />} />
      <Route path="/register/concluded" element={<RegisterConcluded />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register/email" element={<RegisterEmail />} />
      <Route path="/register/password" element={<RegisterPassword />} />
      <Route path="/publictokens" element={<PublicList />} />
      <Route path="/publictokenslite" element={<PublicListLite />} />
      <Route path="/reset" element={<ResetPassword />} />
      <Route path="*" element={!noAuthPaths.includes(pathname) ? <Navigate to="/login" /> : ''} />
    </Routes>
  );

  if (props.isAuthenticated) {
    return (
      <>
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          <Index />
        </Suspense>
      </>
    );
  } else {
    return (
      <div className="vh-100">
        <Suspense
          fallback={
            <div id="preloader">
              <div className="sk-three-bounce">
                <div className="sk-child sk-bounce1"></div>
                <div className="sk-child sk-bounce2"></div>
                <div className="sk-child sk-bounce3"></div>
              </div>
            </div>
          }
        >
          {publicRoutes}
        </Suspense>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(Investor));
